module.exports = __webpack_public_path__ + "media/stylesheets/images/martech/icon_arrow_red_circle_prev-164eec7a83ce9c1b997268549493480d.svg";